"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getONCompliancePeriodicReport = exports.getONComplianceReport = void 0;
const shared_1 = require("@getgreenline/shared");
const getONComplianceReport = (companyId, responseType, filter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/reports/compliance`, {
        params: Object.assign(Object.assign({}, filter), { responseType }),
    });
    return response.data;
});
exports.getONComplianceReport = getONComplianceReport;
const getONCompliancePeriodicReport = (companyId, reportType, params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/company/${companyId}/reports/compliance/periodic/${reportType}`, {
        params: params,
    });
    return response.data;
});
exports.getONCompliancePeriodicReport = getONCompliancePeriodicReport;
//# sourceMappingURL=ONComplianceApi.js.map